import React, { useState } from "react";
import {
  Modal,
  Button,
  Form,
  Select,
  Row,
  Col,
  Input,
  message,
  Spin,
} from "antd";
import { CustomInput, CustomPasswordInput } from "./customInput";
import { customWhite, green } from "../constants/colors";
import axios from "axios";
import { baseUrl } from "../utills";
import { useNavigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa6";
import { FaPhone } from "react-icons/fa";
import GoogleLoginButton from "./googleLoginButton";
import logo from "../assets/images/MSM MOTOR LOGO.png";
const LoginForm = ({ setOpenModal3, setOpenModal2 }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { Option } = Select;
  const [formLayout, setFormLayout] = useState("vertical");
  const [messageApi, contextHolder] = message.useMessage();
  const [form2] = Form.useForm();

  const formItemLayout =
    formLayout === "horizontal"
      ? {
          labelCol: {
            span: 4,
          },
          wrapperCol: {
            span: 14,
          },
        }
      : null;
  const buttonItemLayout =
    formLayout === "horizontal"
      ? {
          wrapperCol: {
            span: 14,
            offset: 4,
          },
        }
      : null;

  const logIn = async (values) => {
    setLoading(true);
    try {
      const res = await axios.post(baseUrl + "signin", values);
      // console.log("signin", res);
      if (res?.status === 200) {
        setLoading(false);
        console.log("login res", res);
        localStorage.setItem("user_id", res?.data?.user?.user_id);
        localStorage.setItem("access_token", res?.data?.access_token);
        // const expiryTime = Date.now() + 24 * 60 * 60 * 1000;
        // localStorage.setItem("tokenExpiry", expiryTime);
        localStorage.setItem("login_data", JSON.stringify(res?.data));
        localStorage.setItem("role", res?.data?.user?.role);

        messageApi.open({
          type: "success",
          content: "Logged in successfully!",
        });
        // setOpenModal3(false);
        if (res?.data?.user?.role == "admin") {
          navigate("/admin-layout");
        } else {
          navigate("/layout");
        }
      }
    } catch (error) {
      setLoading(false);
      messageApi.open({
        type: "error",
        content: error?.response?.data?.detail,
      });

      console.error("error....", error);
    }
  };
 
  const handleLoginWithGoogle = async (values) => {
    setLoading(true);
    try {
      const res = await axios.get(baseUrl + "login_with_google");
      if (res?.status === 200) {
        setLoading(false);
        console.log("login res", res);
        messageApi.open({
          type: "success",
          content: "Logged in successfully!",
        });
        navigate("/layout");
      }
    } catch (error) {
      setLoading(false);
      messageApi.open({
        type: "error",
        content: error?.response?.data?.detail,
      });

      console.error("error....", error);
    }
  };
  return (
    <div className="w-[95%] sm:w-[80%] md:w-[80%] lg:w-[50%] xl:w-[30%] m-auto pt-6 pb-20 bg-white rounded rounded-[10px] px-8 border border-gray-300 bg-gradient-to-b from-[#F3E1E1] to-white">
      {contextHolder}
      <Spin spinning={loading} className="custom-spin">
        <Form
          {...formItemLayout}
          layout={formLayout}
          form={form2}
          name="form2"
          onFinish={logIn}
          initialValues={{
            layout: formLayout,
          }}
        >
          <img src={logo} className="m-auto w-[160px] h-[75px] mb-2" alt="" />
          <div className="border-b border-gray-300 mb-6">
            <p className="text-[22px] text-center font-[700] ms-2 mb-4">
              Welcome to <span className="text-customGreen">MSM Motor</span>
            </p>
            {/* <p className="text-[16px] text-center font-[500] mt-0 ms-2 mb-4">
              Enter your email and password to login
            </p> */}
          </div>

          <Row gutter={[23, 0]}>
            <Col xs={24}>
              <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>Email</p>
                }
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please! enter your email address",
                  },
                ]}
              >
                <CustomInput placeholder="Enter your email address" />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>Password</p>
                }
                name="password"
                rules={[
                  { required: true, message: "Please enter your address" },
                ]}
              >
                <CustomPasswordInput placeholder="Enter your password" />
              </Form.Item>
            </Col>
          </Row>
          <div className="block sm:flex justify-between items-center mb-4 text-center sm:text-end">
            <p className="text-[17px] text-customGray text-center font-[400] md:ms-2 mb-2 sm:mb-[unset]">
              Don't have an account yet?{" "}
              <span
                onClick={() => navigate("/sign-up")}
                className="text-black font-[500] hover:cursor-pointer hover:text-customGreen"
              >
                Sign Up
              </span>
            </p>
            <a
              className="hover:text-customGreen underline hover:underline font-[500]"
              onClick={()=>navigate("/forgot-password")}
            >
              Forgot Password?
            </a>
          </div>
          <Form.Item
            //   style={{
            //     display: "flex",
            //   }}
            {...buttonItemLayout}
          >
            <Button
              size="large"
              style={{
                marginTop: "10px",
                backgroundColor: green,
                borderColor: green,
                color: customWhite,
                borderRadius: "5px",
                width: "100%",
                //   marginLeft: "10px",
                height: "48px",
                fontWeight: 500,
              }}
              type="primary"
              htmlType="submit"
            >
              Log In
            </Button>
          </Form.Item>

          {/* <p className="text-[17px] text-customGray text-center font-[400] mb-2 ms-2">
            or
          </p> */}
          {/* <Button
            size="large"
            onClick={handleLoginWithGoogle}
            style={{
              marginTop: "10px",
              backgroundColor: "transparent",
              color: "black",
              borderRadius: "5px",
              width: "100%",
              height: "48px",
              fontWeight: 500,
              position: "relative",
              boxShadow: "none",
            }}
            type="primary"
            className="hover border border-gray-300 hover:border-customGreen"
          >
            <FcGoogle className="text-2xl absolute left-[15%] md:left-[20%] top-1/2 transform -translate-x-[15%] md:-translate-x-[20%] -translate-y-1/2" />
            Continue with Google
          </Button> */}


          {/* <GoogleLoginButton /> */}


          {/* <Button
            size="large"
            style={{
              marginTop: "10px",
              backgroundColor: "transparent",
              borderColor: green,
              color: "black",
              borderRadius: "5px",
              width: "100%",
              height: "48px",
              fontWeight: 500,
              position: "relative",
            }}
            type="primary"
          >
            <FaFacebook
              style={{
                fontSize: "24px",
                position: "absolute",
                left: "20%",
                top: "50%",
                transform: "translate(-20%, -50%)",
                color: "blue",
              }}
            />{" "}
            Continue with Facebook
          </Button>
          <Button
            size="large"
            style={{
              marginTop: "10px",
              backgroundColor: "transparent",
              borderColor: green,
              color: "black",
              borderRadius: "5px",
              width: "100%",
              height: "48px",
              fontWeight: 500,
              position: "relative",
            }}
            type="primary"
          >
            <FaPhone
              style={{
                fontSize: "24px",
                position: "absolute",
                left: "20%",
                top: "50%",
                transform: "translate(-20%, -50%)",
                color: "gray",
              }}
            />{" "}
            Continue with Phone
          </Button> */}
        </Form>
      </Spin>
    </div>
  );
};

export default LoginForm;
